import { APP_ROUTES } from '@routes/routes.constants';
import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import type { SalesforceRedirectContentProps } from './SalesforceRedirectContent.types';

import { SalesforceRedirectContentInner } from '../content-inner/SalesforceRedirectContentInner';
import styles from './SalesforceRedirectContent.module.css';

const SalesforceRedirectContent = React.memo(
  ({
    state,
    importOrganization,
    syncUser,
    retry,
  }: Readonly<SalesforceRedirectContentProps>): React.ReactElement | null => {
    const navigate = useNavigate();

    const handleGoHome = React.useCallback((): void => {
      navigate(APP_ROUTES.APP_INITIALIZER, { replace: true });
    }, [navigate]);

    if (state.step === 'invalid-params') {
      return <InlineFeedback type="bad-request" />;
    }

    return (
      <div
        className={styles.salesforceRedirectContent}
        data-testid="sf-redirect-content"
      >
        <SalesforceRedirectContentInner
          state={state}
          importOrganization={importOrganization}
          syncUser={syncUser}
          retry={retry}
          onGoHome={handleGoHome}
        />
      </div>
    );
  }
);

SalesforceRedirectContent.displayName = 'SalesforceRedirectContent';

export { SalesforceRedirectContent };
